<template>
  <div
    class="circle-progress"
    :class="{
      theme,
    }"
    :style="{
      '--size': size,
    }"
  >
    <div class="circle-clone"></div>
    <div
      ref="circle"
      class="circle"
    />
  </div>
</template>

<script>
import EventBus from '@/eventBus'

export default {
  props: {
    theme: {
      type: String,
      default: 'light',
    },
    size: {
      type: String,
      default: '28px',
    },
    countTimeToAnswer: {
      type: String,
      default: null,
    },
  },
  data() {
    return {}
  },
  mounted() {
    this.resetTimeToAnswer(this.countTimeToAnswer)
    EventBus.$on('resetCycle', (value) => {
      this.resetTimeToAnswer(value, 'EventBus')
    })
  },
  destroyed() {
    EventBus.$off('resetCycle')
  },
  methods: {
    resetTimeToAnswer(value) {
      this.$refs.circle.style.animation = 'none'
      this.$refs.circle.focus()
      this.$refs.circle.style.animation = null
      this.$refs.circle.style.animationDuration = value

      this.$nextTick(() => {
        setTimeout(() => {
          this.$emit('countDownReady')
        }, 0)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";

@keyframes progress {
  0% {
    clip-path: polygon(50% 50%, 50% -50%, 150% 50%, 50% 150%, -50% 50%, 50% -50%);
  }
  25% {
    clip-path: polygon(50% 50%, 150% 50%, 50% 150%, -50% 50%, 50% -50%, 50% -50%);
  }
  50% {
    clip-path: polygon(50% 50%, 50% 150%, -50% 50%, 50% -50%, 50% -50%, 50% -50%);
  }
  75% {
    clip-path: polygon(50% 50%, -50% 50%, 50% -50%, 50% -50%, 50% -50%, 50% -50%);
  }
  100% {
    clip-path: polygon(50% 50%, 50% -50%, 50% -50%, 50% -50%, 50% -50%, 50% -50%);
  }
}

.circle-progress {
  @apply flex items-center justify-center;
  position: relative;

  &.dark {
    .circle-clone {
      border: solid 5px #E0E0E0;
    }
  }
}

.circle-clone {
  @apply absolute top-0 left-0;
  @apply w-full h-full rounded-full;
  content: '';
  width: var(--size);
  height: var(--size);
  border: solid 5px #B4BCCF;
}

.circle {
  position: relative;
  width: var(--size);
  height: var(--size);
  border-radius: 50%;
  display: inline-block;
  border: solid 5px $primary-color;
  animation: progress linear forwards;
}
</style>
